export default __webpack_public_path__ + "media/images/svg/burger-679651a88efab17a1c8938947269f90a.svg";